import * as angular from 'angular';
import { CreditGapsClassOfTableComponent } from './credit-gaps-class-of-table.component';

export const CreditGapsClassOfTableModule = angular
  .module('creditGapsClassOfTableModule', [])
  .component('creditGapsClassOfTable', CreditGapsClassOfTableComponent).name;
